import { IconButton } from '@material-ui/core';
import React from 'react';
import ReactDOM from 'react-dom';
import { CerrarIcon } from '../../assets/icons';
import useStyles from './ModalStyles';
var Modal = function (_a) {
    var children = _a.children, className = _a.className, cerrarModal = _a.cerrarModal;
    var element = document.getElementById('modal');
    var styles = useStyles();
    return element
        ? ReactDOM.createPortal(React.createElement("div", { className: styles.backdrop },
            React.createElement("section", { className: styles.modal + " " + className },
                React.createElement(IconButton, { "aria-label": "cerrar", className: styles.cerrarButton, onClick: cerrarModal },
                    React.createElement(CerrarIcon, { className: styles.cerrarIcon })),
                children)), element)
        : null;
};
Modal.defaultProps = {
    className: '',
};
export default Modal;
